const apLocations = {
  "Andhra Pradesh": {
    "Alluri Sitharama Raju": [
      "Araku Valley",
      "Paderu",
      "Rampachodavaram"
    ],

    "Anakapalli": [
      "Anakapalle",
      "Chodavaram",
      "Elamanchili",
      "Madugula",
      "Narsipatnam",
      "Payakaraopet",
      "Pendurthi"
    ],

    "Ananthapuramu": [
      "Anantapur Urban",
      "Guntakal",
      "Kalyandurg",
      "Raptadu",
      "Rayadurg",
      "Singanamala",
      "Tadipatri",
      "Uravakonda"
    ],

    "Annamayya": [
      "Kodur",
      "Madanapalle",
      "Pileru",
      "Rajampet",
      "Rayachoti",
      "Thamballapalle"
    ],

    "Bapatla": [
      "Addanki",
      "Bapatla",
      "Chirala",
      "Parchur",
      "Repalle",
      "Vemuru"
    ],

    "Chittoor": [
      "Chittoor",
      "Gangadhara Nellore",
      "Kuppam",
      "Nagari",
      "Palamaner",
      "Punganur",
      "Puthalapattu"
    ],

    "East Godavari": [
      "Anaparthy",
      "Gopalapuram",
      "Kovvur",
      "Nidadavole",
      "Rajanagaram",
      "Rajahmundry City",
      "Rajahmundry Rural"
    ],

    "Eluru": [
      "Chintalapudi",
      "Denduluru",
      "Eluru",
      "Kaikalur",
      "Nuzvid",
      "Polavaram",
      "Unguturu"
    ],

    "Guntur": [
      "Guntur East",
      "Guntur West",
      "Mangalagiri",
      "Ponnuru",
      "Prathipadu",
      "Tadikonda",
      "Tenali"
    ],

    "Kadapa": [
      "Badvel",
      "Jammalamadugu",
      "Kadapa",
      "Kamalapuram",
      "Mydukur",
      "Proddatur",
      "Pulivendula"
    ],

    "Kakinada": [
      "Anaparthy",
      "Jaggampeta",
      "Kakinada City",
      "Kakinada Rural",
      "Peddapuram",
      "Pithapuram",
      "Prathipadu",
      "Tuni"
    ],

    "Konaseema": [
      "Amalapuram",
      "Gannavaram",
      "Kothapeta",
      "Mandapeta",
      "Mummidivaram",
      "Ramachandrapuram",
      "Razole"
    ],

    "Krishna": [
      "Avanigadda",
      "Gannavaram",
      "Gudivada",
      "Machilipatnam",
      "Pamarru",
      "Pedana",
      "Penamaluru"
    ],

    "Kurnool": [
      "Adoni",
      "Alur",
      "Kodumur",
      "Kurnool",
      "Mantralayam",
      "Pattikonda",
      "Yemmiganur"
    ],

    "Nandyal": [
      "Allagadda",
      "Banaganapalle",
      "Dhone",
      "Nandikotkur",
      "Nandyal",
      "Panyam",
      "Srisailam"
    ],

    "Nellore": [
      "Atmakur",
      "Kandukur",
      "Kavali",
      "Kovur",
      "Nellore City",
      "Nellore Rural",
      "Sarvepalli",
      "Udayagiri"
    ],

    "NTR": [
      "Jaggayyapeta",
      "Mylavaram",
      "Nandigama",
      "Tiruvuru",
      "Vijayawada Central",
      "Vijayawada East",
      "Vijayawada West"
    ],

    "Palnadu": [
      "Chilakaluripet",
      "Gurajala",
      "Macherla",
      "Narasaraopet",
      "Pedakurapadu",
      "Sattenapalle",
      "Vinukonda"
    ],

    "Parvathipuram Manyam": [
      "Kurupam",
      "Palakonda",
      "Parvathipuram",
      "Salur"
    ],

    "Prakasam": [
      "Darsi",
      "Giddalur",
      "Kanigiri",
      "Kondapi",
      "Markapuram",
      "Ongole",
      "Santhanuthalapadu",
      "Yerragondapalem"
    ],

    "Sri Sathya Sai": [
      "Dharmavaram",
      "Hindupur",
      "Kadiri",
      "Madakasira",
      "Penukonda",
      "Puttaparthi"
    ],

    "Srikakulam": [
      "Amadalavalasa",
      "Etcherla",
      "Ichchapuram",
      "Narasannapeta",
      "Palasa",
      "Pathapatnam",
      "Srikakulam",
      "Tekkali"
    ],

    "Tirupati": [
      "Chandragiri",
      "Gudur",
      "Sathyavedu",
      "Srikalahasti",
      "Sullurpeta",
      "Tirupati",
      "Venkatagiri"
    ],

    "Visakhapatnam": [
      "Bheemunipatnam",
      "Gajuwaka",
      "Visakhapatnam East",
      "Visakhapatnam North",
      "Visakhapatnam South",
      "Visakhapatnam West"
    ],

    "Vizianagaram": [
      "Bobbili",
      "Cheepurupalli",
      "Gajapathinagaram",
      "Nellimarla",
      "Rajam",
      "Srungavarapukota",
      "Vizianagaram"
    ],

    "West Godavari": [
      "Achanta",
      "Bhimavaram",
      "Narasapuram",
      "Palakollu",
      "Tanuku",
      "Tadepalligudem",
      "Undi"
    ]
  },

  "Telangana": {
    "Adilabad": [
      "Adilabad",
      "Boath"
    ],

    "Kumaram Bheem Asifabad": [
      "Sirpur",
      "Asifabad"
    ],

    "Mancherial": [
      "Chennur",
      "Bellampalli",
      "Mancherial"
    ],

    "Nirmal": [
      "Khanapur",
      "Nirmal",
      "Mudhole"
    ],

    "Nizamabad": [
      "Armur",
      "Bodhan",
      "Nizamabad Urban",
      "Nizamabad Rural",
      "Balkonda"
    ],

    "Kamareddy": [
      "Jukkal",
      "Banswada",
      "Yellareddy",
      "Kamareddy"
    ],

    "Jagtial": [
      "Koratla",
      "Jagtial",
      "Dharmapuri"
    ],

    "Peddapalli": [
      "Ramagundam",
      "Manthani",
      "Peddapalle"
    ],

    "Karimnagar": [
      "Karimnagar",
      "Choppadandi",
      "Manakondur",
      "Huzurabad"
    ],

    "Rajanna Sircilla": [
      "Vemulawada",
      "Sircilla"
    ],

    "Siddipet": [
      "Husnabad",
      "Siddipet",
      "Dubbak",
      "Gajwel"
    ],

    "Medak": [
      "Medak",
      "Narsapur"
    ],

    "Sangareddy": [
      "Narayankhed",
      "Andole",
      "Zahirabad",
      "Sangareddy",
      "Patancheru"
    ],

    "Medchal-Malkajgiri": [
      "Medchal",
      "Malkajgiri",
      "Quthbullapur",
      "Kukatpally",
      "Uppal"
    ],

    "Rangareddy": [
      "Ibrahimpatnam",
      "Lal Bahadur Nagar",
      "Maheshwaram",
      "Rajendranagar",
      "Serilingampally",
      "Shadnagar"
    ],

    "Vikarabad": [
      "Chevella",
      "Pargi",
      "Vikarabad",
      "Tandur"
    ],

    "Hyderabad": [
      "Musheerabad",
      "Malakpet",
      "Amberpet",
      "Khairatabad",
      "Jubilee Hills",
      "Sanathnagar",
      "Nampally",
      "Karwan",
      "Goshamahal",
      "Charminar",
      "Chandrayangutta",
      "Yakutpura",
      "Bahadurpura",
      "Secunderabad",
      "Secunderabad Cantonment"
    ],

    "Mahabubnagar": [
      "Kodangal",
      "Mahbubnagar",
      "Jadcherla"
    ],

    "Narayanpet": [
      "Narayanpet",
      "Makthal"
    ],

    "Nagarkurnool": [
      "Devarkadra",
      "Nagarkurnool",
      "Achampet",
      "Kalwakurthy",
      "Kollapur"
    ],

    "Wanaparthy": [
      "Wanaparthy"
    ],

    "Jogulamba Gadwal": [
      "Gadwal",
      "Alampur"
    ],

    "Nalgonda": [
      "Devarakonda",
      "Nagarjuna Sagar",
      "Miryalaguda",
      "Nalgonda",
      "Munugode",
      "Nakrekal"
    ],

    "Suryapet": [
      "Huzurnagar",
      "Kodad",
      "Suryapet",
      "Thungathurthi"
    ],

    "Yadadri Bhuvanagiri": [
      "Bhongir",
      "Alair"
    ],

    "Jangaon": [
      "Jangaon",
      "Ghanpur Station",
      "Palakurthi"
    ],

    "Mahabubabad": [
      "Dornakal",
      "Mahabubabad"
    ],

    "Warangal": [
      "Narsampet",
      "Warangal East"
    ],

    "Hanumakonda": [
      "Parkal",
      "Warangal West",
      "Wardhannapet"
    ],

    "Jayashankar Bhupalpally": [
      "Bhupalpalle"
    ],

    "Mulugu": [
      "Mulug"
    ],

    "Bhadradri Kothagudem": [
      "Pinapaka",
      "Yellandu",
      "Kothagudem",
      "Aswaraopeta",
      "Bhadrachalam"
    ],

    "Khammam": [
      "Khammam",
      "Palair",
      "Madhira",
      "Wyra",
      "Sathupalli"
    ]
  }
};

export default apLocations;